/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2017 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import ally from 'ally.js';

const LoadingSpinner = () => {
    return (
        <div className="pe-loadingSpinner">
            <div className="pe-loadingSpinner-container pe-loadingSpinner-container1">
                <div className="circle1"></div>
                <div className="circle2"></div>
                <div className="circle3"></div>
                <div className="circle4"></div>
            </div>
            <div className="pe-loadingSpinner-container pe-loadingSpinner-container2">
                <div className="circle1"></div>
                <div className="circle2"></div>
                <div className="circle3"></div>
                <div className="circle4"></div>
            </div>
        </div>
    );
};

class Spinner extends Component {
    static propTypes = {
        active: PropTypes.bool,
        id: PropTypes.string.isRequired,
        data: PropTypes.shape({
            text: PropTypes.shape({
                chipText: PropTypes.string.isRequired
            })
        })
    };

    constructor(props) {
        super(props);
        this.state = {
            active: props.active,
            chipVertPos: 0
        };

        this.toggleLoader = this.toggleLoader.bind(this);
        this.toggleTabbableItems = this.toggleTabbableItems.bind(this);
    }

    convertToJSX(htmlStr) {
        const htmlObj = {
            __html: htmlStr
        };

        return (
            <div dangerouslySetInnerHTML={htmlObj} className={'loadingIndicatorContent-' + this.props.id} aria-hidden={this.state.active}/>
        );
    }

    toggleLoader() {
        const newActive = this.state.active;
        this.setState({ active: newActive,
            tabElements: this.toggleTabbableItems(newActive)
        });
    }

    toggleTabbableItems(newActive) {
        const tabElementArr = this.state.tabElements;
        for (let i = 0; i < tabElementArr.length; i++) {
            tabElementArr[i].tabIndex = newActive === false ? 0 : -1;
        }
        return tabElementArr;
    }

    componentDidMount() {
        const chipHeight = 70;
        const windowVert = Math.floor((window.innerHeight - chipHeight) / 2);
        const chipVertPosWIN = (windowVert < 0) ? 0 : windowVert;
        const overlayHeight = ReactDOM.findDOMNode(this).parentNode.clientHeight;
        const chipVertPos = this.props.appLevel ? chipVertPosWIN : 0 - overlayHeight;
        const tabbableConfig = this.props.appLevel ? { context: 'body' } : { context: '.loadingIndicatorContent-' + this.props.id };
        const tabElements = ally.query.tabbable(tabbableConfig);

        if (this.state.active) {
            for (let i = 0; i < tabElements.length; i++) {
                tabElements[i].tabIndex = -1;
            }
        }

        this.setState({
            chipVertPos: chipVertPos,
            tabElements: tabElements
        });
    }

    componentDidUpdate(prevProps) {
        if (prevProps.active !== this.props.active) {
            this.setState({ active: this.props.active });
        }
    }

    render() {
        const { appLevel, children, data, htmlString } = this.props;
        const { active } = this.state;
        const overlayStyle = appLevel ? 'pe-loadingIndicator-overlay-app' : 'pe-loadingIndicator-overlay';
        const chipStyle = appLevel ? {marginTop: this.state.chipVertPos} : {top: this.state.chipVertPos};
        const activeStyle = active ? '' : ' pe-loadingIndicator-overlay-inactive';
        const childrenContent = children ? (<div aria-hidden={this.state.active} className={'loadingIndicatorContent-' + this.props.id}>{children}</div>) : this.convertToJSX(htmlString);
        const chipTextWidth = data.text.chipText.length > 20 ? {width: 140} : {};

        return (
            <div className="pe-loadingIndicator">
                <div className={overlayStyle + activeStyle}>
                    <div className="pe-loadingIndicator-chip" style={chipStyle}>
                        <LoadingSpinner />
                        <div className="pe-loadingIndicator-chip-text" style={chipTextWidth}>{data.text.chipText}</div>
                    </div>
                </div>
                <div aria-live="polite" aria-busy={active}>
                    {childrenContent}
                </div>
            </div>
        );
    }
}

export default Spinner;



// WEBPACK FOOTER //
// ./src/components/widgets/shareModal/spinner.js